"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCyHelper = exports.dataCy = void 0;
var _react = require("react");
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _Rating = _interopRequireDefault(require("@mui/material/Rating"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["name", "value", "size", "onChange", "error", "helper"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'rating';
var dataCyHelper = exports.dataCyHelper = 'rating-helper';
var Rating = function Rating(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    onChange = _ref.onChange,
    error = _ref.error,
    helper = _ref.helper,
    props = _objectWithoutProperties(_ref, _excluded);
  var helperText = helper || error;
  var hasError = !!error;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Rating["default"], _objectSpread(_objectSpread({
      name: name,
      value: value || 0,
      size: size,
      onChange: onChange
    }, props), {}, {
      "data-cy": dataCy
    })), helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], {
      error: hasError,
      "data-cy": dataCyHelper,
      children: helperText
    }) : null]
  });
};
Rating.propTypes = {
  /**
   * 	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes["default"].number,
  /**
   * If true, the rating will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The icon to display when empty.
   */
  emptyIcon: _propTypes["default"].node,
  /**
   * The label read when the rating input is empty.
   */
  emptyLabelText: _propTypes["default"].node,
  getLabelText: _propTypes["default"].func,
  /**
   * <Star fontSize="inherit" />	The icon to display.
   */
  icon: _propTypes["default"].node,
  IconContainerComponent: _propTypes["default"].elementType,
  /**
   * Maximum rating.
   */
  max: _propTypes["default"].number,
  /**
   * 	The name attribute of the radio input elements.
   *  If readOnly is false, the prop is required,
   *  this input name`should be unique within the parent form.
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the value changes.
   */
  onChange: _propTypes["default"].func,
  /**
   * The minimum increment value change allowed.
   */
  precision: _propTypes["default"].number,
  /**
   * Removes all hover effects and pointer events.
   */
  readOnly: _propTypes["default"].bool,
  /**
   * The size of the rating.
   */
  size: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  /**
   * The rating value.
   */
  value: _propTypes["default"].number,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  helper: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
var _default = exports["default"] = Rating;